import { render, staticRenderFns } from "./GetTogetherSignup.vue?vue&type=template&id=2b264c9a&scoped=true"
import script from "./GetTogetherSignup.vue?vue&type=script&lang=js"
export * from "./GetTogetherSignup.vue?vue&type=script&lang=js"
import style0 from "./GetTogetherSignup.vue?vue&type=style&index=0&id=2b264c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b264c9a",
  null
  
)

export default component.exports